import Autoplay from 'embla-carousel-autoplay';

import { Carousel, CarouselContent, CarouselItem } from '@app/shared/ui/atoms/Common';
import { CarouselDots } from '@app/shared/ui/molecules/Common';
import { WhatIsDomBanner, BannerCard } from '@app/shared/ui/organisms/Cognition';
import { useCognitionCarousel } from '@app/shared/hooks/useCognitionCarousel';
import { cn } from '@app/shared/utils/common';

export function CarouselSection() {
  const { banners, handleSlideChange, currentIndex, isVideoHidden, toggleVideoHidden } =
    useCognitionCarousel();

  return (
    <section className="relative">
      <Carousel
        onSlideChange={handleSlideChange}
        plugins={isVideoHidden ? [Autoplay({ delay: 3000, stopOnInteraction: false })] : []}
        opts={{ loop: true }}
      >
        <CarouselContent className="h-[210px]" overlayClassName="rounded-xl">
          {banners.map((banner) => {
            if (banner.variant === 'what_is_dom') {
              return (
                <CarouselItem
                  key={banner.variant}
                  className={cn(
                    'flex flex-col rounded-xl bg-cover bg-center',
                    isVideoHidden && 'p-3 pb-7'
                  )}
                  style={{ backgroundImage: `url(${banner.img})` }}
                >
                  <WhatIsDomBanner
                    isVideoHidden={isVideoHidden}
                    toggleVideoHidden={toggleVideoHidden}
                  />
                </CarouselItem>
              );
            }

            return <BannerCard key={banner.img} banner={banner} />;
          })}
        </CarouselContent>
      </Carousel>

      {isVideoHidden && (
        <div className="absolute bottom-2 right-2 rounded-xl bg-gray-400/80 p-1">
          <CarouselDots
            carouselLength={banners.length}
            currentIndex={currentIndex}
            colorMode="white"
          />
        </div>
      )}
    </section>
  );
}
